<template>
<div>
  <div class="q-field__native inline no-wrap items-center mw-form-v2-toggle-label-padding">{{ field.label }}</div>
    <div @scroll="onScroll" :style="{'height':this.field.options && this.field.options.height ? this.field.options.height + 'px' : '200px', 'overflow' : 'hidden scroll', 'padding':'10px', 'border':'1px solid #f0e0e0', 'border-radius': '10px'}">
      <div class="html_content" v-html="field.description"></div>
    </div>


  <q-field class="field_no_bottom_line" :hide-bottom-space="true" v-model="fieldValue"  :rules="field.required ? [ val => val && val === 'Yes' || requiredText] : []">
  </q-field>
</div>
</template>

<script>
import {mapFields} from "vuex-map-fields";
export default {
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {

    };
  },
  emits: ['update:modelValue'],
  methods: {
    onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
      if (scrollTop + clientHeight >= scrollHeight -10) {
        this.fieldValue = "Yes";
      }
    }
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select';
    },
    fieldValue: {
      get() {
        return this.modelValue==='Yes' ? 'Yes' : false;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {

  }
}
</script>
